<template>
    <section>
        <div id="subHeader">
            <h1>quem somos</h1>
            <h2>a nossa historia</h2>
        </div>
        <div class="container-fluid" id="main">
            <div class="row">
                <div class="col-12 col-xl-7 mb-5" id="text-stuff" v-html="quemSomos.description"></div>
                <div class="col">
                    <div class="d-flex">
                        <img alt="" class="m-auto" id="qsBanner" :src="quemSomos.image">
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "QuemSomos",
        metaInfo: {
            title: 'Quem Somos',
        },
        data() {
            return {
                quemSomos: {}
            }
        },
        mounted() {
            this.$parent.image = '/images/quemSomos.jpg';
        },
        beforeRouteEnter(to, from, next) {
            axios.post('/quem-somos')
                .then(rsp => next(vm => {
                    //rsp.data.description = rsp.data.description.replace(/(<([^>]+)>)/ig, "");
                    vm.quemSomos = rsp.data;
                }))
        },
        watch: {}
    }
</script>

<style lang="scss" scoped>
    #qsBanner {
        height: 100%;
        width: 100%;
        object-fit: contain;
        object-position: center;
    }
</style>